module.exports = "/_next/static/images/img__tips_cube_top-left-16adef8e2d2ed02d922839276fde0a62.png";